import type { AnyRoute } from "@tanstack/react-router";

import { createSensorAssignmentsListRoutes } from "./createSensorAssignmentsListRoutes";
import type { SensorAssignmentsRouteDeps } from "./sensorAssignmentsRouteContext";

export type {
  SensorAssignmentsRouteDeps,
  SensorAssignmentsRouteFactory,
} from "./sensorAssignmentsRouteContext";

export function createSensorAssignmentsRoutes(
  deps: SensorAssignmentsRouteDeps,
): AnyRoute[] {
  return [...createSensorAssignmentsListRoutes(deps)];
}
